import { apiFetch } from '../apiFetch'

export const getNearbyDungeons = async (lat, lng) => {
  return await apiFetch({
    path: `/dungeons/nearby?lat=${lat}&lng=${lng}`
  })
}

export const getDungeon = async (id) => {
  return await apiFetch({
    path: `/dungeons/${id}`
  })
}

export const createDungeon = async (data) => {
  return await apiFetch({
    path: '/host/dungeons',
    method: 'POST',
    payload: data
  })
}

export const updateDungeon = async (id, data) => {
  return await apiFetch({
    path: `/host/dungeons/${id}`,
    method: 'PUT',
    payload: data
  })
}

export const collectUniqueTreasure = (dungeonSlug, treasureId, treasureBehavior, saveId) =>
  apiFetch({
    path: `/dungeons/${dungeonSlug}/collect`,
    method: 'POST',
    payload: { treasure_id: treasureId, treasure_behavior: treasureBehavior, save_id: saveId || undefined },
  })

export const recordMonsterKill = (dungeonSlug, monsterId) =>
  apiFetch({
    path: `/dungeons/${dungeonSlug}/kill`,
    method: 'POST',
    payload: { monster_id: monsterId },
  })

export const createHostDungeonNpc = (dungeonId, data) =>
  apiFetch({ path: `/host/dungeons/${dungeonId}/npcs`, method: 'POST', payload: data })

export const updateHostDungeonNpc = (dungeonId, placementId, data) =>
  apiFetch({ path: `/host/dungeons/${dungeonId}/npcs/${placementId}`, method: 'PUT', payload: data })

export const deleteHostDungeonNpc = (dungeonId, placementId) =>
  apiFetch({ path: `/host/dungeons/${dungeonId}/npcs/${placementId}`, method: 'DELETE' })

export const getDungeonChat = (slug) =>
  apiFetch({ path: `/dungeons/${slug}/chat` })

export const postDungeonChat = (slug, message, characterName) =>
  apiFetch({ path: `/dungeons/${slug}/chat`, method: 'POST', payload: { message, character_name: characterName || undefined } })
